import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import CustomCircularProgress from "../../Components/Loading/CustomCircularProgress.jsx"
import { CustomAvatar } from "../../Components/CustomAvatar.jsx"
import { createProductor, getAllsProductores } from "../../endpoints.js"
import Swal from "sweetalert2";
import { uploadToS3 } from "../../endpoints.js"

const ModalCreateProductor =
  ({
    closeModalCreateProductor,
    stopPropagation,
    obtenerProductores
  }) => {
    const [loader, setLoader] = useState(false);
    const [errors, setErrors] = useState({
      nombre: '',
      apellido: '',
      telefono: '',
      email: '',
      password: '',
    });

    const [formData, setFormData] = useState({
      nombre: '',
      apellido: '',
      telefono: '',
      email: '',
      password: '',
      imagen_profile: '',
      type: 'Productor'

    });

    const checkName = () => {
      if (!formData?.nombre?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          nombre: 'El nombre es obligatorio',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          nombre: '',
        }));
      }
    }

    const checkApellido = () => {
      if (!formData?.apellido?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          apellido: 'El apellido es obligatorio',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          apellido: '',
        }));
      }
    }

    const checkEmail = () => {
      if (!formData?.email?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          email: 'El email es obligatorio',
        }));
      } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
        setErrors(prevErrors => ({
          ...prevErrors,
          email: 'El email ingresado no es válido',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          email: '',
        }));
      }
    }

    const checkPassword = () => {
      if (!formData?.password?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          password: 'La contraseña es obligatoria',
        }));
      } else if (formData.password.length < 8) {
        setErrors(prevErrors => ({
          ...prevErrors,
          password: 'La contraseña debe tener al menos 8 caracteres',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          password: '',
        }));
      }
    }

    const checkTelefono = () => {
      if (!formData?.telefono?.trim()) {
        setErrors(prevErrors => ({
          ...prevErrors,
          telefono: 'El teléfono es obligatorio',
        }));
      } else if (!/^\d{10}$/.test(formData.telefono)) {
        setErrors(prevErrors => ({
          ...prevErrors,
          telefono: 'El teléfono debe contener 10 números',
        }));
      } else {
        setErrors(prevErrors => ({
          ...prevErrors,
          telefono: '',
        }));
      }
    }

    const handleCancelar = () => {

      closeModalCreateProductor();
    };
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };


    const handleChangeImg = async (e) => {
      setLoader(true);
      const selectedFile = e.target.files[0];

      const formData = new FormData();
      formData.append('file', selectedFile);
      uploadToS3(formData).then((res) => {
        if (res.status === 200) {

          console.log(res.data.photoUrl)
          setFormData(prevErrors => ({
            ...prevErrors,
            imagen_profile: res.data.photoUrl,
          }));

          setLoader(false);
        } else {
          setLoader(false);
          Swal.fire({
            icon: "error",
            title: "Ocurrio un error al subir la imagen",
            confirmButtonText: "Listo",
            confirmButtonColor: "#6f120f",
          });
        }

      })

    };

    const checkErrors = () => {
      checkEmail()
      checkPassword()
      checkTelefono()
      checkApellido()
      checkName()
    }

    const createAsesorSubmit = async () => {
      checkErrors()
      if (
        errors.nombre === '' &&
        errors.apellido === '' &&
        errors.telefono === '' &&
        errors.email === '' &&
        errors.password === ''
      ) {
        createProductor({
          name: formData.nombre,
          lastname: formData.apellido,
          email: formData.email,
          photo: formData.imagen_profile,
          password: formData.password,
          userType: formData.type,
          phone: formData.telefono,
        }).then((res) => {
          if (res.status === 200) {
            closeModalCreateProductor()
            Swal.fire({
              icon: "success",
              title: "El Productor fue creado con exito",
              confirmButtonText: "Listo",
              confirmButtonColor: "#003049",
            });
            obtenerProductores()
          } else {
            Swal.fire({
              icon: "error",
              title: "Usuario ya registrado",
              confirmButtonText: "Listo",
              confirmButtonColor: "#6f120f",
            });
          }
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Revise los campos y vuevla a intentar",
          confirmButtonText: "Listo",
          confirmButtonColor: "#6f120f",
        });
        console.log(errors)
      }
    }

    return (
      <ModalWrapper onClick={handleCancelar}>
        <DivColumn onClick={stopPropagation}>
          <Text1>
            Formulario de Creación de Productor
          </Text1>
          <DivRowContent>
            <ContImg>
              {loader ? (
                <ConLoader>
                  <CustomCircularProgress size={23} />
                </ConLoader>
              ) : null}
              <label htmlFor="update-image-profile">
                <CustomAvatar loader={loader} avatarStyle={100} srcImage={formData.imagen_profile} />
                <InputImage
                  type="file"
                  id="update-image-profile"
                  name="imagen_profile"
                  accept=".jpeg, .png, .jpg"
                  onChange={(e) => handleChangeImg(e)}
                />
              </label>
            </ContImg>
            <ContentFormGrid>
              <FormGroup>
                <Label htmlFor="nombre">Nombre *</Label>
                <Input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  placeholder='Ingrese nombre'
                  onBlur={checkName}
                />
                {errors.nombre && <ErrorMessage>{errors.nombre}</ErrorMessage>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="apellido">Apellido *</Label>
                <Input
                  type="text"
                  id="apellido"
                  name="apellido"
                  value={formData.apellido}
                  onChange={handleChange}
                  placeholder='Ingrese apellido'
                  onBlur={checkApellido}
                />
                {errors.apellido && <ErrorMessage>{errors.apellido}</ErrorMessage>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="telefono">Telefono *</Label>
                <Input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  placeholder='Ingrese telefono'
                  onBlur={checkTelefono}
                />
                {errors.telefono && <ErrorMessage>{errors.telefono}</ErrorMessage>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="email">Email *</Label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder='Ingrese email'
                  onBlur={checkEmail}
                />
                {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
              </FormGroup>
              <FormGroup>
                <Label htmlFor="password">Contraseña *</Label>
                <Input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder='Ingrese contraseña'
                  onBlur={checkPassword}
                />
                {errors.password && <ErrorMessage>{errors.password}</ErrorMessage>}
              </FormGroup>
            </ContentFormGrid>
          </DivRowContent>
          <Text2>
            {"Los campos que cuenta con un * son obligatorios."}
          </Text2>
          <BtnCrearAsesor onClick={createAsesorSubmit}>
            CREAR PRODUCTOR
          </BtnCrearAsesor>
        </DivColumn>
      </ModalWrapper>

    );
  };

export default ModalCreateProductor;
const DivRowContent = styled.div`
  display:flex;
  flex-direction:row;
  align-items:flex-start;
  gap:16px;
  width: -webkit-fill-available;
  @media only screen and (min-width:0px) and (max-width:1100px){
    flex-direction:column;
 }
`;
const InputImage = styled.input`
  display: none;
`;
const ConLoader = styled.div`
  position: absolute;
  z-index: 5;
  left: auto;
  top: auto;
  // border:solid 1px red;
`;

const ContImg = styled.div`
  display: flex;
  display: flex;
  position: relative;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 767px) and (max-width: 1100px) {
    align-items: center;
  }
`;

const Text2 = styled.span`
color:#003049;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 12px;
margin-bottom:16px;
align-self: end;
`

const Text1 = styled.span`
color:#003049;
font-family: 'Montserrat', sans-serif;
font-weight: 700;
font-size: 22px;
margin-bottom:30px;
`

const BtnCrearAsesor = styled.div`
  width:150px;
  margin:0px 0px;
  height:30px;
  border-radius:8px;
  background-color:#003049;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  color:#ffffff;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 12px;
  cursor:pointer;
  align-self: end;
  &:hover{
    background-color:#006295;
  }
`;

const ErrorMessage = styled.div`
  color: red;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
font-weight: 800;
font-size: 11px;
// color: #07082c;
`;

const FormGroup = styled.div`
  // margin-bottom: 20px;
  display:flex;
  flex-direction: column;
  gap:8px;
//   border:solid 1px red;
min-height:75px;
flex-grow:1;
flex-basis:200px
`;
const Label = styled.label`
font-family: 'Montserrat', sans-serif;
font-weight: 800;
font-size: 14px;
color: #07082c;
`;
const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
`;
const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ContentFormGrid = styled.div`
display:flex;
flex-wrap:wrap;
gap: 8px;
box-sizing: border-box;
width: -webkit-fill-available;
`;

const DivColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 40vw;
    margin: 0px 0% 0% 0%;
    padding: 16px 16px;
    border-radius: 8px;
    background-color: #FFFFFF;
    gap: 0px;
    // min-height: 90vh;
    heigth: auto;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
    @media only screen and (min-width:0px) and (max-width:1100px){
      width:100%;
      min-height:95vh;
      margin-top:5vh;

      padding: 10px 16px 50px 16px;
      box-sizing: border-box;
    }
`;
